import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Icon, { iconNames } from './icon';
import { TooltipBlock } from './blocks';
import { COLORS } from '../../constants';
import { MapRedirect } from './MapRedirect';
import { isHighlightActive } from './Card';

export const BadgeStickerForAdvert = ({ item }) => {
    const { t } = useTranslation();
    const badgeText = useMemo(() => {
        switch (item.rating) {
            case 0:
                return t('premium');
            case 1:
                return t('top-1');
            case 2:
                return t('top-2');
            case 3:
                return t('top-3');
            default:
                return null;
        }
    }, [item.rating, t]);

    const showSpecialSale =
        item.rating === 0 || item.rating === 1 || isHighlightActive(item);

    return (
        <>
            {item.rating < 4 && (
                <span className="status-badge status-badge-top">
                    <Icon name={iconNames.top} size={22} fill={COLORS.GREEN} />
                    {badgeText}
                </span>
            )}
            {showSpecialSale && (
                <span className="status-badge status-badge-specialSale">
                    <Icon name={iconNames.clock} size={22} />
                    {t('specialSale')}
                </span>
            )}
            {item.city ? (
                <span className="status-badge status-badge-city">
                    <Icon name={iconNames.location} size={16} />
                    <MapRedirect item={item} />
                </span>
            ) : item.cityCompany ? (
                <span className="status-badge status-badge-city">
                    <Icon name={iconNames.location} size={16} />
                    <MapRedirect item={item} isCompany />
                </span>
            ) : null}
        </>
    );
};

export const TopBadge = ({ item }) => {
    const { t } = useTranslation();
    const badgeText = useMemo(() => {
        switch (item.rating) {
            case 0:
                return t('premium');
            case 1:
                return t('top-1');
            case 2:
                return t('top-2');
            case 3:
                return t('top-3');
            default:
                return null;
        }
    }, [item.rating, t]);

    return item.rating < 4 ? (
        <div className="top-badge">
            {item.fastSell && (
                <TooltipBlock
                    id="fastSell"
                    className="top-badge__fastSell"
                    icon={iconNames.fastSell}
                    size={18}
                    fill={COLORS.DARKRED_LIGHT}
                />
            )}
            {badgeText}
        </div>
    ) : null;
};
